<div class="filters px-16" *appVar="viewUpdate$ | async" data-cy="Fund cash filters">
  <div class="search-field">
    <ion-icon name="search-outline"></ion-icon>
    <ion-input
      [formControl]="searchControl"
      [placeholder]="'quote.filters.search' | translate"
      data-cy="Fund cash search input"
    ></ion-input>
    <ion-button
      *ngIf="(searchControl.value ?? '').length"
      fill="clear"
      class="clear-search-button"
      (click)="clearSearch()"
      data-cy="Clear fund cash search input"
      mode="ios"
    >
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="filters-actions">
    <ion-button
      fill="clear"
      class="fs-13 filters-text filter-button"
      [class.filter-button--active]="hasActiveModalFilters"
      (click)="openFiltersModal()"
      data-cy="Open fund cash filters modal"
      mode="ios"
    >
      <ion-icon slot="start" name="funnel"></ion-icon>
      {{ 'quote.filters.filter' | translate }}
      <span *ngIf="hasActiveModalFilters" class="filter-button__dot" aria-hidden="true"></span>
    </ion-button>
  </div>
</div>
